import EditButton from "../../../components/EditButton";
import type { TableColumn } from "../../../components/tables/CustomPaginatedTable/types";
import type { DigitalAsset } from "./types";

interface GetDigitalAssetColumnsParams {
  canEdit: boolean;
  canViewOffice: boolean;
  hasSelectedRows: boolean;
  onView: (asset: DigitalAsset) => void;
  onEdit: (asset: DigitalAsset) => void;
  onOpenOffice?: (officeCode: string) => void;
}

const normalize = (value?: string | number | null): string => String(value ?? "");

export const getDigitalAssetColumns = ({
  canEdit,
  canViewOffice,
  hasSelectedRows,
  onView,
  onEdit,
  onOpenOffice,
}: GetDigitalAssetColumnsParams): TableColumn<DigitalAsset>[] => [
  {
    title: "Digital Asset",
    field: "name",
    render: (asset) => (
      <button
        type="button"
        className="blueAndBold underline"
        onClick={() => onView(asset)}
      >
        {asset.name}
      </button>
    ),
    cellStyle: {
      textAlign: "left",
      width: 200,
      fontSize: "12px",
    },
  },
  {
    title: "Office Name",
    field: "officeName",
    render: (asset) =>
      canViewOffice && onOpenOffice ? (
        <button
          type="button"
          className="blueAndBold underline"
          onClick={() => onOpenOffice(asset.officeCode)}
        >
          {asset.officeName}
        </button>
      ) : (
        asset.officeName
      ),
    cellStyle: {
      textAlign: "left",
      width: 300,
      fontSize: "12px",
    },
  },
  {
    title: "Office Code",
    field: "officeCode",
  },
  {
    title: "Corp. Office #",
    field: "storeNumber",
    render: (asset) => normalize(asset.storeNumber),
  },
  {
    title: "Online Directories Brand Name",
    field: "online_Directories_Brand_Name__C",
    cellStyle: {
      textAlign: "left",
      width: 200,
      fontSize: "12px",
    },
  },
  {
    title: "Agency",
    field: "agency",
    render: (asset) => normalize(asset.agency),
  },
  {
    title: "Office Status",
    field: "officeStatus",
    render: (asset) => normalize(asset.officeStatus),
  },
  {
    title: "Digital Tracking Number",
    field: "digital_Tracking_Number__C",
    render: (asset) => normalize(asset.digital_Tracking_Number__C),
  },
  {
    title: "Action",
    sortable: false,
    align: "center",
    render: (asset) =>
      canEdit ? (
        <div className="flex place-content-center mr-4">
          <EditButton
            className={hasSelectedRows ? "opacity-50" : "opacity-100"}
            disabled={hasSelectedRows}
            buttonText="Edit"
            onClick={() => onEdit(asset)}
          />
        </div>
      ) : null,
  },
];